import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const antiBullying_hws = {
	/**
	 * 修改设备管理员的席位
	 * @param data
	 * @returns {AxiosPromise}
	 */
	updateDeviceManagerSeat(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/anti-bullying/v1/seat/node`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},

	/**
	 * 新增设备管理员席位并授权设备
	 * @returns {AxiosPromise}
	 */
	addDeviceManagerSeat(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/anti-bullying/v1/seat/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},

	deleteDeviceManagerSeat(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/anti-bullying/v1/seat/delete`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},

	/**
	 * 获取所有设备树
	 * nodeId: 0 默认查所有
	 * @param nodeId
	 */
	getDeviceTree(nodeId) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/anti-bullying/v1/device/tree`,
			headers: config.headers,
			params: { nodeId }
		});
	},
	/**
	 * 校验席位是否有效
	 * @param hwsAccountName
	 * @returns {AxiosPromise}
	 */
	checkSeat(hwsAccountName) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/anti-bullying/v1/seat/check`,
			headers: config.headers,
			params: { hwsAccountName }
		});
	},
	/**
	 * 获取坐席账户设备节点权限信息
	 * @param hwsAccountName
	 * @returns {AxiosPromise}
	 */
	getSeatDeviceAuth(hwsAccountName) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/anti-bullying/v1/seat/hwsAccount`,
			headers: config.headers,
			params: { hwsAccountName }
		});
	},

	refreshOneSeat(schoolId, deviceManagerId) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/anti-bullying/v1/seat/refresh/hwsAccount`,
			headers: config.headers,
			params: { schoolId, deviceManagerId }
		});
	},

	refreshAllSeat(schoolId) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/anti-bullying/v1/seat/refresh/hwsAccount`,
			headers: config.headers,
			params: { schoolId }
		});
	},

	/**
	 * 通过设备序列号获取设备报警信息
	 * @param serialNumList
	 * @returns {Promise<APIResponse>}
	 */
	getDeviceLogBySnList(serialNumList, page, perPage) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/anti-bullying/v1/device/alert-record`,
			headers: config.headers,
			params: { serialNumList, page, perPage }
		});
	}
};
export default antiBullying_hws;
